import { VisaulGuideStepItemType } from 'modules/Appointments/VisualGuide/types';

import bookSlotSrc from '@common/assets/images/appointments-visual-guide/book-slot.webp';
import selectSubject from '@common/assets/images/appointments-visual-guide/select-subject.png';
import selectTeacherLyceum from '@common/assets/images/appointments-visual-guide/select-teacher-lyceum.png';
import selectWeekSrc from '@common/assets/images/appointments-visual-guide/lyceum-select-week.png';

const VISUAL_GUIDE_STEPS: VisaulGuideStepItemType[] = [
	{
		title: 'appointment.lyceumVisualGuide.selectSubject',
		imageSrc: selectSubject,
		altImageName: 'selectSubject',
	},
	{
		title: 'appointment.lyceumVisualGuide.selectTeacher',
		imageSrc: selectTeacherLyceum,
		altImageName: 'selectTeacher',
	},
	{
		title: 'appointment.lyceumVisualGuide.selectWeek',
		imageSrc: selectWeekSrc,
		altImageName: 'selectWeek',
	},
	{
		title: 'appointment.visualGuide.bookSlot',
		imageSrc: bookSlotSrc,
		altImageName: 'bookSlot',
	},
];

export default VISUAL_GUIDE_STEPS;
